import React from 'react';

import {
  SidebarListItemContainer,
  SidebarListItemIcon,
  SidebarListItemText,
} from 'src/components/sidebar/sidebar-items/SidebarListItem';
import {
  APP_BUILDER_BROWSE_TAB_PATH,
  APP_BUILDER_BUILD_TAB_PATH,
} from 'src/constants';
import { RouteContext } from 'src/context';
import { useAppBuilderAccess } from 'src/hooks/useAppBuilderAccess';
import useNavigate from 'src/hooks/useNavigate';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import { useRouteAccess } from 'src/routes/routeAccess';
import { togglePrimarySidebarMobile } from 'src/store/ui/actions';

export const AddAppSidebarItem = () => {
  const { navigate } = useNavigate();
  const dispatch = useAppDispatch();
  const isClient = useAppSelector((state) => state.user.isClient);
  const isPrimarySidebarOpenOnMobile = useAppSelector(
    (state) => state.ui.primarySideBarMobile.isOpen,
  );
  const { enableAppBuilder } = useAppBuilderAccess();
  const { routeAccess } = useRouteAccess();
  const { pathname } = React.useContext(RouteContext);

  const canAccess = !isClient && routeAccess.allowSettingsModuleManagement;

  if (!canAccess) return null;

  // Don't highlight when inside a specific builder session — that route owns
  // the corresponding draft sidebar item, which surfaces its own active state.
  const isOnAppSetupRoute =
    pathname.includes('/app-setup/build') &&
    !pathname.includes('/app-setup/build/session/');

  const targetPath = enableAppBuilder
    ? APP_BUILDER_BUILD_TAB_PATH
    : APP_BUILDER_BROWSE_TAB_PATH;

  // Mirror the other sidebar items: collapse the mobile drawer after
  // navigating so it doesn't stay open over the destination page.
  const handleClick = () => {
    navigate(targetPath);
    if (isPrimarySidebarOpenOnMobile) {
      dispatch(togglePrimarySidebarMobile({ isOpen: false }));
    }
  };

  return (
    <SidebarListItemContainer
      htmlId="sidebar-add-app"
      handleClick={handleClick}
      selected={isOnAppSetupRoute}
    >
      <div className="flex items-center opacity-60">
        <SidebarListItemIcon className="min-w-6" iconName="Plus" />
        <SidebarListItemText text="Add App" />
      </div>
    </SidebarListItemContainer>
  );
};
